import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { BookOpen } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-warm-alt relative overflow-hidden" data-id="element-210">
      <div className="max-w-6xl mx-auto px-6" data-id="element-211">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-212">
          <div className="lg:w-1/2" data-id="element-213">
            <FadeIn data-id="element-214">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-warm-accent/10 text-warm-accent font-medium text-sm mb-6" data-id="element-215">
                <BookOpen className="w-4 h-4" data-id="element-216" />
                <span data-id="element-217">Presentando Espalda Libre</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-6 leading-tight" data-id="element-218">
                Cuando el dolor cambia tu vida, necesitas un nuevo camino
              </h2>

              <div className="space-y-6 text-warm-dark/80 text-lg leading-relaxed" data-id="element-219">
                <p data-id="element-220">
                  <strong data-id="element-221">Espalda Libre</strong> no es un libro técnico ni una
                  promesa de recuperación rápida.
                </p>
                <p data-id="element-222">
                  Es una guía práctica basada en experiencia real, creada para
                  ayudarte a entender mejor tu proceso y recuperar confianza en
                  tu cuerpo paso a paso.
                </p>
              </div>

              {/* Highlighted insight block */}
              <div className="my-10 text-center" data-id="element-223">
                <h3 className="font-heading text-2xl md:text-3xl font-semibold text-warm-dark mb-5 leading-snug" data-id="element-224">
                  No necesitas más ejercicios. Necesitas claridad.
                </h3>
                <div className="space-y-4 text-warm-dark/70 text-base md:text-lg leading-relaxed" data-id="element-225">
                  <p data-id="element-226">
                    En internet encontrarás miles de ejercicios para la espalda.
                  </p>
                  <p data-id="element-227">Lo difícil no es encontrarlos.</p>
                  <p data-id="element-228">
                    Lo difícil es saber cuáles hacer, cuándo avanzar y cómo
                    adaptarlos a tu situación sin sentirte perdido entre
                    información contradictoria.
                  </p>
                  <p data-id="element-229">
                    <strong data-id="element-230">Espalda Libre</strong> organiza el proceso paso a
                    paso para ayudarte a entender qué hacer, cuándo avanzar y
                    cómo recuperar confianza en tu movimiento.
                  </p>
                </div>
              </div>

              <div className="mt-10 text-center lg:text-left" data-id="element-231">
                <Button href="#comprar" data-id="element-232">Descubrir el contenido</Button>
              </div>
            </FadeIn>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-233">
            <FadeIn direction="left" delay={0.2} data-id="element-234">
              <div className="relative w-full max-w-md mx-auto aspect-[3/4] bg-warm-bg rounded-2xl shadow-xl overflow-hidden border border-warm-accent/20 flex flex-col" data-id="element-235">
                <div className="h-1/2 bg-warm-accent/10 relative overflow-hidden flex items-center justify-center p-8" data-id="element-236">
                  <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-warm-accent to-transparent" data-id="element-237"></div>
                  <h3 className="font-heading text-4xl text-warm-dark text-center relative z-10 leading-tight" data-id="element-238">
                    Espalda
                    <br data-id="element-239" />
                    <span className="italic text-warm-accent" data-id="element-240">Libre</span>
                  </h3>
                </div>
                <div className="h-1/2 p-8 flex flex-col justify-between bg-white" data-id="element-241">
                  <div data-id="element-242">
                    <p className="text-sm text-warm-dark/60 uppercase tracking-widest mb-2" data-id="element-243">
                      Ebook Digital
                    </p>
                    <p className="font-heading text-xl text-warm-dark leading-snug" data-id="element-244">
                      Mi historia real de recuperación sin cirugía
                    </p>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-245">
                    <div className="w-10 h-10 rounded-full bg-warm-alt flex items-center justify-center" data-id="element-246">
                      <BookOpen className="w-5 h-5 text-warm-accent" data-id="element-247" />
                    </div>
                    <p className="text-sm text-warm-dark/70" data-id="element-248">
                      Lectura práctica y accesible
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}